// The single navigation target for a mounted app. Node IDs and the selected workspace ID are
// authoritative route inputs; AppInstance.scope_path is a denormalized display value and may use
// either firm-prefixed or workspace-rooted topology, so it must not be parsed to build a route.
import { navTo } from "./navTargets";

export interface AppTarget {
  workspaceId: string;
  scopeNodeId: string;
  appId: string;
  /** Current scope when opening a visible inherited placement, omitted for saved session targets. */
  readerScopeNodeId?: string;
}

export function resolveAppTarget({ workspaceId, scopeNodeId, appId, readerScopeNodeId }: AppTarget): ReturnType<typeof navTo.nodeApp> {
  // DtV sessions belong to the scope where they are created. An inherited placement enables
  // the app there; opening it must retain that reader scope and its parent client.
  const targetNodeId = appId === "brainstorming" && readerScopeNodeId ? readerScopeNodeId : scopeNodeId;
  return navTo.nodeApp(workspaceId, targetNodeId, appId);
}
